<div class="min-h-screen bg-gradient-to-br from-primary via-secondary via-dark to-accent flex items-center justify-center p-4">
  <div class="bg-base-100 rounded-2xl shadow-2xl p-12 w-full max-w-md">
    <!-- Header with Masasana Branding -->
    <div class="text-center mb-8">
      <div class="bg-gradient-to-r from-primary via-secondary to-accent bg-clip-text text-transparent font-[Dosis] text-4xl font-bold mb-2">
        AIMS
      </div>
      <p class="text-base-content/70 font-[Lato] m-0">AI Management & EU AI Act Schulungssystem</p>
    </div>

    <!-- Error Message -->
    @if (errorMessage) {
      <div class="alert alert-error mb-6 font-[Lato]">
        <i class="fas fa-exclamation-triangle mr-2"></i>
        {{ errorMessage }}
      </div>
    }

    <!-- Keycloak Login -->
    <div class="mb-8">
      <p class="text-base-content/70 font-[Lato] text-center mb-6">
        Melden Sie sich mit Ihrem Masasana-Konto an:
      </p>
      
      <button 
        type="button"
        (click)="login()"
        [disabled]="isLoading"
        class="btn btn-accent w-full py-3.5 px-6 text-base font-semibold font-[Dosis] transition-opacity duration-200 flex items-center justify-center gap-3"
        [class.opacity-70]="isLoading"
      >
        <i class="fas fa-sign-in-alt"></i>
        @if (isLoading) {
          <span class="flex items-center gap-2">
            <i class="fas fa-spinner fa-spin"></i>
            Weiterleiten...
          </span>
        } @else {
          <span>Mit Masasana anmelden</span>
        }
      </button>
    </div>

    <!-- Information Section -->
    <div class="border-t border-base-300 pt-6 text-center">
      <p class="text-base-content/70 font-[Lato] text-sm m-0">
        Powered by <strong>Masasana AI</strong> • Secure Authentication via Keycloak
      </p>
    </div>
  </div>
</div>


